import { Input, Modal, notification } from "antd";
import queryKeys from "common/queryKey";
import { useQueryState } from "hooks/useQueryState";
import { useUpdate } from "hooks/useUpdate";
import moment from "moment";
import React from "react";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getUserInfo } from "redux/selectors";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";

const DeclineTimesheetModal = ({ open, setOpen, selectedTimesheetKeys, setSelectedTimesheetKeys }) => {
  const { updateTimesheet, getTimesheet } = queryKeys;
  const [reason, setReason] = React.useState("");
  const queryClient = useQueryClient();

  const { week } = useParams();

  const { data: timesheetDataRes } = useQueryState(
    `${getTimesheet.key}-week:${week}`
  );

  const timesheetData = timesheetDataRes?.response?.response || {};

  const userInfo = useSelector((state) => getUserInfo(state));

  const { mutate: update, isLoading: isUpdating } = useUpdate(
    updateTimesheet.key,
    updateTimesheet.url
  );

  const handleOk = () => {
    if (!reason) {
      notification.error({
        message: "Error",
        description: "Please Enter the Reason",
      });
      return;
    }

    let newTimeSheet = [...timesheetData.timeSheet];

    for (let i = 0; i < selectedTimesheetKeys?.length; i++) {
      const idx = selectedTimesheetKeys[i];
      if (newTimeSheet[idx]) {
        newTimeSheet[idx] = {
          ...newTimeSheet[idx],
          status: "declined",
          declined: {
            by: userInfo.employer_id,
            date: moment().format("DD-MM-YYYY"),
            reason,
          },
        };
      }
    }

    update(
      {
        ...timesheetData,
        timeSheet: newTimeSheet,
      },
      {
        onSuccess: (res) => {
          queryClient.invalidateQueries(`${getTimesheet.key}-week:${week}`);
          notification.success({
            message: "Timesheet Declined Successfully",
          });
          setOpen(false);
          setSelectedTimesheetKeys([]);
        },
      }
    );
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>

      <Modal
        title="Reason for Decline"
        open={open}
        onCancel={handleCancel}
        footer={[
          <ButtonOutlined key="cancel" onClick={handleCancel}>
            Cancel
          </ButtonOutlined>,
          <ButtonFilled
            key="decline"
            loading={isUpdating}
            onClick={handleOk}
          >
            Decline
          </ButtonFilled>,
        ]}
      >
        <Input
          name="reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Please Enter the Reason"
        />
      </Modal>
    </>
  );
};

export default DeclineTimesheetModal;
